export default __webpack_public_path__ + "static/media/List-documentation.547d686d.md";